import React from 'react'
import keyBy from 'lodash/keyBy'
import {
  TextField,
  useQuery,
  Datagrid,
  Pagination,
  ListContextProvider,
  FunctionField,
} from 'react-admin'
import { formatDate } from '../../utils'
import { usePagination } from '../../../hooks'

export const TournamentsList = (props) => {
  const { page, perPage, setPage, setPerPage } = usePagination()
  const currentClubId = props.record.id
  const { data, total } = useQuery({
    type: 'getList',
    resource: `clubs/${currentClubId}/tournaments`,
    payload: {
      pagination: { page, perPage },
      sort: { field: 'id', order: 'ASC' },
    },
  })
  return (
    <ListContextProvider
      value={{
        resource: 'tournaments',
        basePath: '/clubs',
        data: keyBy(data, 'id'),
        ids: data?.map((el) => el.id),
        currentSort: { field: 'id', order: 'ASC' },
        selectedIds: [],
      }}
    >
      <Datagrid rowClick={(id) => `/tournaments/${id}`}>
        <TextField source='name' label='Название' />
        <TextField source='sportKind' label='Вид спорта' />
        <TextField source='owner.fullName' label='Организатор' />
        <TextField source='place' label='Место' emptyText='Не указано' />
        <TextField source='city.name' label='Город' emptyText='Не указано' />
        <TextField source='address' label='Адрес' emptyText='Не указано' />
        <TextField
          source='owner.phone'
          label='Номер телефона'
          emptyText='Не указано'
        />
        <FunctionField
          label='Период проведения'
          render={(record) =>
            `C ${formatDate(record.dateStart)} по ${formatDate(record.dateEnd)}`
          }
        />
      </Datagrid>
      <Pagination
        page={page}
        perPage={perPage}
        setPage={setPage}
        total={total}
        setPerPage={setPerPage}
      />
    </ListContextProvider>
  )
}
